import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearchComponent({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M10.875 10.875c.621 0 1.125.504 1.125 1.125v5.625c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125V12c0-.621.504-1.125 1.125-1.125h4.5zm7.875 3.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-2.25c0-.621.504-1.125 1.125-1.125h4.5zM10.875 12h-4.5v5.625h4.5V12zm7.875 3.375h-4.5v2.25h4.5v-2.25zm0-10.125c.621 0 1.125.504 1.125 1.125V12c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.125 12V6.375c0-.621.504-1.125 1.125-1.125h4.5zm0 1.125h-4.5V12h4.5V6.375zM10.875 5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 5.25 8.625v-2.25c0-.621.504-1.125 1.125-1.125h4.5zm0 1.125h-4.5v2.25h4.5v-2.25z"/>
        </svg>
    );
}

export default IconSearchComponent;
